import React from 'react';
import { FiLayers, FiRefreshCw } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const batchSizes = [1, 5, 15];

function BatchControls({ batchSize, onBatchSizeChange, onGenerate }) {
  return (
    <section className="batch-controls">
      <div>
        <span className="control-label">MĂRIME LOT</span>
        <div className="batch-options">
          {batchSizes.map((size) => (
            <button
              className={batchSize === size ? 'is-active' : ''}
              type="button"
              key={size}
              onClick={() => onBatchSizeChange(size)}
            >
              {size} {size === 1 ? 'VARIANTĂ' : 'VARIANTE'}
            </button>
          ))}
        </div>
      </div>
      <button className="generate-button" type="button" onClick={onGenerate}>
        <SafeIcon icon={batchSize > 1 ? FiLayers : FiRefreshCw} />
        GENEREAZĂ {batchSize > 1 ? `LOT DE ${batchSize}` : 'NUMERE'}
        <span>↗</span>
      </button>
    </section>
  );
}

export default BatchControls;